/**
 * Created by Victor Rojo on 25/9/17.
 */
import { HttpRequest, HttpHandler, HttpEvent,
HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { tap }        from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private inj: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
      }, (err: any) => {
        if ( err instanceof HttpErrorResponse ) {
          if (err.status === 401) {
            const authService = this.inj.get(AuthService);
            authService.logout( sessionStorage.getItem("auth_token") ? true : false );
          }
        }
      }));
  }

}
